import URI from 'urijs';

export const GOOGLE_SEARCH_START = 'GOOGLE_SEARCH_START';
export const GOOGLE_SEARCH_SUCCESS = 'GOOGLE_SEARCH_SUCCESS';
export const GOOGLE_SEARCH_ERROR = 'GOOGLE_SEARCH_ERROR';

export const TRANSLATE_START = 'TRANSLATE_START';
export const TRANSLATE_SUCCESS = 'TRANSLATE_SUCCESS';
export const TRANSLATE_ERROR = 'TRANSLATE_ERROR';

export const INPUT_SEARCH = 'INPUT_SEARCH';
export const RESET = 'RESET';
export const SELECT_SOURCE = 'SELECT_SOURCE';

export const TOGGLE_TRANSLATE_RESULTS = 'TOGGLE_TRANSLATE_RESULTS';

export const searchInGoogle = query => ({fetch}) => ({
  type: 'GOOGLE_SEARCH',
  payload: {
    promise: fetch(URI().pathname('/api/v1/search').query(query).toString())
      .then(res => res.json())
  }
});

export const toggleTranslateResults = val => ({
  type: TOGGLE_TRANSLATE_RESULTS,
  payload: {val}
});

export const inputSearch = query => ({
  type: INPUT_SEARCH,
  payload: {query}
});

export const reset = query => ({
  type: RESET
});

export const translateQuery = ({q, targetLanguage, sourceLanguage}) => ({fetch}) => ({
  type: 'TRANSLATE',
  payload: {
    promise: fetch(URI().pathname('/api/v1/translate')
      .query({
        q,
        targetLanguage,
        sourceLanguage
      }).toString())
      .then(res => res.json())
  }
});

export const onSelectSource = searchSource => ({
  type: SELECT_SOURCE,
  payload: searchSource
});



// WEBPACK FOOTER //
// ./src/common/search/actions.js